import { Box, Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';
import FeesList from '../../components/Fees/FeesList';
import FeesToolbar, {
    FeeSortKey,
    TypeFilter,
} from '../../components/Fees/FeesToolbar';
import UserRole from '../../../shared/AuthRoles';
import { useNavigate } from 'react-router-dom';
import { CustomButton } from '../../../layout/styledcomponents/CustomButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { ExperienceType } from '../../enums/experience';

const FeesPage = () => {
    const isMobile = useMediaQuery('(max-width: 770px)');
    const isIpad = useMediaQuery('(max-width: 1200px)');
    const loggedInUser = UserRole();
    const navigate = useNavigate();
    const theme = useTheme();

    useEffect(() => {
        if (loggedInUser.role !== 'owner_admin') {
            navigate(`/permissionDenied`, { state: { name: 'feesPage' } });
        }
    }, [loggedInUser.role, navigate]);

    // ---- toolbar state ----
    const [query, setQuery] = useState('');
    const [typeFilter, setTypeFilter] = useState<TypeFilter>('All');
    const [expFilter, setExpFilter] = useState<ExperienceType[]>([]);
    const [sortKey, setSortKey] = useState<FeeSortKey>('nameAsc');

    const onClickGoBack = () => navigate(`/adminCentre/host`);

    return (
        <Grid
            sx={{
                width: '100%',
                height: isMobile || isIpad ? '100%' : '95%',
                justifyContent: 'left',
                alignItems: 'center',
            }}
        >
            {/* Shared content container so toolbar + list edges line up */}
            <Box sx={{ px: { xs: 2, md: 0 }, width: '100%' }}>
                {/* Title */}
                <Grid
                    sx={{
                        width: '100%',
                        height: isMobile || isIpad ? 'auto' : '5%',
                        justifyContent: 'left',
                        display: 'flex',
                        mb: 1.5,
                    }}
                >
                    <Typography
                        variant='h1'
                        sx={{
                            textAlign: 'left',
                            textTransform: 'uppercase',
                        }}
                    >
                        Fee Types
                    </Typography>
                </Grid>

                {/* Toolbar */}
                <Box sx={{ mt: 0.5 }}>
                    <FeesToolbar
                        query={query}
                        onQueryChange={setQuery}
                        typeFilter={typeFilter}
                        onTypeFilterChange={setTypeFilter}
                        expFilter={expFilter}
                        onExpFilterChange={setExpFilter}
                        sortKey={sortKey}
                        onSortKeyChange={setSortKey}
                    />
                </Box>

                {/* List */}
                <Box sx={{ mt: 1.5, pb: 2 }}>
                    <FeesList
                        query={query}
                        typeFilter={typeFilter}
                        expFilter={expFilter}
                        sortKey={sortKey}
                    />
                </Box>

                {/* Back (hidden on small screens) */}
                <Grid
                    sx={{
                        height: '5%',
                        display: isMobile || isIpad ? 'none' : 'flex',
                    }}
                >
                    <CustomButton
                        onClick={onClickGoBack}
                        color='primary'
                        sx={{
                            marginLeft: '-8px',
                            '&:hover': {
                                cursor: 'pointer',
                                color: theme.palette.textAccent.main,
                                backgroundColor: 'transparent',
                                background: 'none',
                            },
                        }}
                    >
                        <ArrowBackIcon />
                        <Typography
                            sx={{ fontSize: '12px', paddingLeft: '5px' }}
                        >
                            Back
                        </Typography>
                    </CustomButton>
                </Grid>
            </Box>
        </Grid>
    );
};

export default FeesPage;
